export const SET_USERS = 'SET_USERS';
export const ADD_USER = 'ADD_USER';
export const TOGGLE_USER_STATUS = 'TOGGLE_USER_STATUS';
export const DELETE_USER = 'DELETE_USER';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const UPDATE_USER = 'UPDATE_USER';